import { render, staticRenderFns } from "./MobileAppBanner.vue?vue&type=template&id=0bb9380f"
import script from "./MobileAppBanner.vue?vue&type=script&lang=js"
export * from "./MobileAppBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports